'use client';

import useStores from '~/store/StoreHook';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useConfigMC } from '~/store/Query/api';
import { CHATBOT_TOKEN_ANON, CHATBOT_TOKEN_AUTH, ESPOTS, QUERY_MOBILE } from '~/store/States/global';
import { handleImageLeave, handleImageToggle } from '~/components/Footer/handlers';

function AgentBot() {
  const { accountStore } = useStores();

  useEffect(() => {
    accountStore.dataPerson(false).then((res) => {
      const userChat = res?.data?.data;
      const logon_id = res?.data?.data?.logon_id;

      const userAuth = userChat?.data;
      const tokenSession = userChat?.token?.access_token;

      const userData = {
        Token: tokenSession ? tokenSession : null,
        Region: tokenSession ? 9 : null,
        Category: tokenSession ? '1' : '2',
        Date: new Date().toISOString(),
        CustomerName:
          tokenSession && userAuth && (userAuth?.first_name || userAuth?.last_name)
            ? `${userAuth?.first_name} ${userAuth?.last_name}`
            : null,
        AccountNumber: tokenSession ? userAuth?.email_1 ?? logon_id : null,
        Email: tokenSession ? userAuth?.email_1 ?? logon_id : null,
        AppType: 'Web',
      };

      const token = tokenSession ? CHATBOT_TOKEN_AUTH : CHATBOT_TOKEN_ANON;

      const scriptAivo = document.createElement('script');
      scriptAivo.classList.add('script-aivo');
      scriptAivo.type = 'text/javascript';
      scriptAivo.src = 'https://cdn.agentbot.net/core/latest/core.js?djMuNi42';

      scriptAivo.onload = () => {
        if (window.$aivo) {
          const { Date, ...restUserData } = userData;
          Object.assign(window, restUserData);
          window.$aivo.run(token);
          window.$aivo.ready?.(function () {
            window.$aivo.user?.set?.(userData);
          });
        }
      };

      document.head.appendChild(scriptAivo);
    });

    return () => {
      const addedScript = document.querySelector('script.script-aivo');
      if (addedScript) {
        addedScript.remove();
      }
    };
  }, []);

  return null;
}

function YellowChatButton({ onClick }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={`cChatEv ${isScrolled ? 'scrolled' : ''}`}
      onClick={onClick}
    >
      <i className="ico ico-message-circle"></i>
      <span>Ayuda</span>
    </div>
  );
}

export default function Chatbox() {
  const { data } = useConfigMC();
  //const isMobile = useMediaQuery({ query: QUERY_MOBILE });

  if (!data?.ok) {
    return null;
  }

  const config = data.body.chatbot;

  function handleOnClick(e) {
    e.preventDefault();
    window.open(config.url, '_blank');
  }

  return (
    config.visible &&
    (config.AMXChatbot ? (
      <AgentBot />
    ) : (
      <>
        <YellowChatButton onClick={handleOnClick} />
        {/*  <a href="#" onClick={handleOnClick} role="button">
        {isMobile ? (
          <picture className="footer--chatbox-mobile">
            <img className="chatbox-mobile" src={`${ESPOTS}/media/chatbox_mobile.png`} alt="image_chatbox_responsive" />
          </picture>
        ) : (
          <picture className="footer--chatbox-pc">
            <img
              src={`${ESPOTS}/media/icon-chat-inicio.gif`}
              alt=""
              onMouseEnter={handleImageToggle}
              onMouseLeave={handleImageLeave}
            />
          </picture>
        )}
      </a>*/}
      </>
    ))
  );
}
